import './pinned-text-reveal.scss';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

function splitLineIntoChars( lineEl ) {
	const text = lineEl.textContent;
	lineEl.innerHTML = '';

	text.split( ' ' ).forEach( ( word, wordIdx, words ) => {
		const wordSpan = document.createElement( 'span' );
		wordSpan.style.display = 'inline-block';
		wordSpan.style.whiteSpace = 'nowrap';

		word.split( '' ).forEach( ( char ) => {
			const clip = document.createElement( 'span' );
			clip.className = 'b-pinnedTextReveal__charClip';

			const charSpan = document.createElement( 'span' );
			charSpan.textContent = char;
			charSpan.className = 'b-pinnedTextReveal__char';

			clip.appendChild( charSpan );
			wordSpan.appendChild( clip );
		} );

		lineEl.appendChild( wordSpan );

		if ( wordIdx < words.length - 1 ) {
			lineEl.appendChild( document.createTextNode( ' ' ) );
		}
	} );
}

function initPinnedTextReveal() {
	const roots = document.querySelectorAll( '[data-component="pinned-text-reveal"]' );

	if ( ! roots.length ) {
		return;
	}

	roots.forEach( ( root ) => {
		const lineWraps = root.querySelectorAll( '.b-pinnedTextReveal__lineWrap' );

		if ( ! lineWraps.length ) {
			return;
		}

		lineWraps.forEach( ( wrap ) => {
			const line = wrap.querySelector( '.b-pinnedTextReveal__line' );
			if ( line ) {
				splitLineIntoChars( line );
			}
		} );

		gsap.set( lineWraps, { autoAlpha: 0 } );
		gsap.set( root.querySelectorAll( '.b-pinnedTextReveal__char' ), {
			yPercent: 100,
			opacity: 0,
		} );

		const tl = gsap.timeline( {
			scrollTrigger: {
				trigger: root,
				start: 'top top',
				end: '+=300%',
				pin: true,
				scrub: 1,
				anticipatePin: 1,
			},
		} );

		lineWraps.forEach( ( wrap, i ) => {
			const chars = wrap.querySelectorAll( '.b-pinnedTextReveal__char' );
			const isLast = i === lineWraps.length - 1;

			tl.to( wrap, { autoAlpha: 1, duration: 0.01 } );
			tl.to( chars, {
				yPercent: 0,
				opacity: 1,
				duration: 1.5,
				stagger: 0.03,
				ease: 'power2.out',
			} );

			if ( ! isLast ) {
				tl.to( chars, {
					yPercent: -100,
					opacity: 0,
					duration: 1.2,
					stagger: 0.02,
					ease: 'power2.in',
				}, '>' );

				tl.to( wrap, { autoAlpha: 0, duration: 0.01 } );
			}
		} );

		root._pinnedTextRevealCleanup = () => {
			if ( tl.scrollTrigger ) {
				tl.scrollTrigger.kill();
			}
			tl.kill();
		};
	} );
}

if ( document.readyState === 'loading' ) {
	document.addEventListener( 'DOMContentLoaded', initPinnedTextReveal );
} else {
	initPinnedTextReveal();
}
